import React, { useEffect, useState } from 'react';
import { Alert, Button, Empty } from 'antd';
import { DownloadOutlined, ExportOutlined, EyeOutlined, FileImageOutlined, FilePdfOutlined, FileTextOutlined } from '@ant-design/icons';
import axios from 'axios';
import API_CONFIG from '../../config/api';
import { ExpenseDocumentViewer, getExpenseDocumentKind } from './ExpenseDocumentPreviewModal';

export default function ExpenseDocumentsPanel({ expense, documents, companyId, moduleScope }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [retry, setRetry] = useState(0);
  const [preview, setPreview] = useState({ loading: true, url: null, contentType: '', error: '' });
  const selectedDocument = documents[selectedIndex];
  const selectedUrl = selectedDocument?.url;
  useEffect(() => {
    if (!selectedUrl) return undefined;
    const controller = new AbortController();
    let blobUrl = null;
    setPreview({ loading: true, url: null, contentType: '', error: '' });
    axios.get(API_CONFIG.apiUrl(`/expenses/${expense.id}/document`), {
      responseType: 'blob', signal: controller.signal, headers: { 'X-Company-Id': companyId },
      params: { company_id: companyId, warehouse_id: expense.warehouse_id, module_scope: moduleScope, document_index: selectedIndex },
    }).then((response) => {
      if (controller.signal.aborted) return;
      blobUrl = URL.createObjectURL(response.data);
      setPreview({ loading: false, url: blobUrl,
        contentType: response.headers?.['content-type'] || response.data?.type || '', error: '' });
    }).catch(() => {
      if (!controller.signal.aborted) setPreview({ loading: false, url: null, contentType: '', error: 'Le document n’a pas pu être chargé.' });
    });
    return () => { controller.abort(); if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [expense.id, expense.warehouse_id, selectedUrl, selectedIndex, companyId, moduleScope, retry]);

  return <section className="expense-documents" aria-label="Documents joints">
    <h3>Documents joints</h3>
    {!documents.length ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Aucun document joint à cette charge." /> : <>
      <ul className="expense-documents__list">{documents.map((document, index) => {
        const kind = getExpenseDocumentKind('', document.name);
        const Icon = kind === 'pdf' ? FilePdfOutlined : kind === 'image' ? FileImageOutlined : FileTextOutlined;
        return <li key={document.key || document.url}><button type="button" aria-pressed={selectedIndex === index}
          onClick={() => setSelectedIndex(index)} className={selectedIndex === index ? 'is-selected' : ''}>
          <Icon aria-hidden="true" className="expense-documents__icon" />
          <span className="expense-documents__name"><strong>{document.name}</strong><small>{kind === 'pdf' ? 'PDF' : kind === 'image' ? 'Image' : 'Document'}</small></span>
          <span className="expense-documents__preview-action"><EyeOutlined aria-hidden="true" /> Aperçu</span>
        </button></li>;
      })}</ul>
      <div className="expense-documents__toolbar">
        <strong>Aperçu · {selectedDocument?.name}</strong>
        <div><Button icon={<ExportOutlined aria-hidden="true" />} href={preview.url || undefined} target="_blank" rel="noopener noreferrer"
          disabled={!preview.url || preview.loading}>Ouvrir</Button>
          <Button icon={<DownloadOutlined aria-hidden="true" />} href={preview.url || undefined} download={selectedDocument?.name}
            disabled={!preview.url || preview.loading}>Télécharger</Button></div>
      </div>
      {preview.error ? <Alert type="error" showIcon message="Aperçu indisponible" description={preview.error}
        action={<Button onClick={() => setRetry((value) => value + 1)}>Réessayer</Button>} />
        : <ExpenseDocumentViewer loading={preview.loading} url={preview.url} fileName={selectedDocument?.name} contentType={preview.contentType} />}
      <p className="expense-modal__help">Si l’aperçu est indisponible, ouvrez ou téléchargez le document.</p>
    </>}
  </section>;
}
